import type { ZeytalTokens } from "@zeytal/types";

import { toKebabCase } from "@endgame/utils/toKebabCase";

import { getColorStyleValue } from "../core/getters/get-color-value.ts";
import { getEffectStyleValue } from "../core/getters/get-effect-value.ts";
import { getFontStyleValue } from "../core/getters/get-font-value.ts";
import { getGridStyleValue } from "../core/getters/get-grid-value.ts";
import { styleNameStartKeyword } from "../utils/tokens.ts";

const structureStyles = (mappedStyles: ZeytalTokens.MappedStyle[]) => {
  const structuredStyles: ZeytalTokens.StructuredStylesArray = mappedStyles.map(
    (mappedStyle) => {
      let styleValue = undefined;

      switch (mappedStyle.styleType) {
        case "FILL":
          styleValue = getColorStyleValue(mappedStyle);
          break;
        case "TEXT":
          styleValue = getFontStyleValue(mappedStyle);
          break;
        case "EFFECT":
          styleValue = getEffectStyleValue(mappedStyle);
          break;
        case "GRID":
          styleValue = getGridStyleValue(mappedStyle);
          break;
      }

      const styleNameOriginal = mappedStyle.name;

      const structuredStyleName = toKebabCase(
        `${styleNameStartKeyword}${styleNameOriginal}`,
      );

      return {
        name: structuredStyleName,
        styleType: mappedStyle.styleType,
        value: styleValue,
      };
    },
  );

  return structuredStyles;
};

export const makeStylesStructure = (
  mappedStyles: ZeytalTokens.MappedStyle[],
) => {
  const structuredStyles = structureStyles(mappedStyles);

  return structuredStyles;
};
